export const Badge = ({ children, className = "", style }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${className}`}
    style={style}
  >
    {children}
  </span>
);

export const PlanBadge = ({ plan, meta }) => {
  const info = meta[plan] || meta.free;
  return (
    <Badge style={{ backgroundColor: info.bgColor, color: info.color, border: `1px solid ${info.borderColor}` }}>
      {info.label}
    </Badge>
  );
};
